var React = require('react');

function FTAirplane (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -60.771)"},[React.createElement("g",{"transform":"translate(0.298 60.771)","key":0},React.createElement("g",{"transform":"translate(0 0)"},React.createElement("path",{"fill":"#2C3D47","d":"M27.4,8.2c-0.4-0.5-3.9-0.5-3.5-0.7L19,10.4l-7.3-2.3l-2.1,1l4.9,4l-4.9,3L7.3,15l-2.2,1.3l3.3,2.3l2.8,0.1\r\n\t\t\t\tl14.5-8C26.5,9.7,27.8,8.7,27.4,8.2z"}))),React.createElement("g",{"transform":"translate(0 73)","key":1},React.createElement("g",{"transform":"translate(0 0)"},React.createElement("rect",{"x":"5.1","y":"9.3","fill":"#2C3D47","width":"21.9","height":"1.4"})))]));
}

FTAirplane.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 32 32"};

module.exports = FTAirplane;

FTAirplane.default = FTAirplane;
